import { NO_OP_CALLBACK } from "@smartrr/shared/constants";
import React from "react";

export const BulkActionCompletedContext = React.createContext<{ onCompleted: () => void }>({
  onCompleted: NO_OP_CALLBACK,
});
